// Find the element with id 'lottie'
var element = document.querySelector('#lottie');

// Define the callback function for the IntersectionObserver
var observerCallback = function (entries, observer) {
    entries.forEach(function (entry) {
        // If the element is in the viewport
        if (entry.isIntersecting) {
            // Stop observing the target element
            observer.unobserve(entry.target);

            // Create a new element of the desired type
            var newElement = document.createElement('lottie-player');

            // Copy the attributes from the old element to the new one
            Array.prototype.forEach.call(element.attributes, function (attr) {
                newElement.setAttribute(attr.name, attr.value);
            });

            // Replace the old element with the new one
            element.parentNode.replaceChild(newElement, element);
        }
    });
};

// Create a new IntersectionObserver
var observerEl = new IntersectionObserver(observerCallback);

// Start observing the target element
observerEl.observe(element);